/**
 * /tenants/$slug/authentication/sign-in — layout of the Sign-in tab.
 *
 * Section nav, Find a setting and the section <Outlet/>; every section is its
 * own child route so it can be linked, bookmarked and reached with back and
 * forward. The layout owns one tenant-settings form for all sections (see
 * features/signin-settings/sign-in-form.tsx).
 *
 * The tenant DETAIL comes from beforeLoad (route context), not a component
 * query, because each save invalidates this query key and then calls
 * router.invalidate() to pull the post-save updated_at into context — two
 * consecutive saves would otherwise race each other's If-Unmodified-Since and
 * the second would 412. staleTime 0: a settings form must open on the server's
 * current row, never a cached one. It must stay on THIS route: a route API
 * resolves only against active matches, so reading it from another layout
 * throws on every visit.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchTenantDetail } from "@/features/tenants/queries";
import { queryKeys } from "@/lib/query-keys";
import { SignInSettingsLayout } from "@/features/signin-settings/pages/sign-in-layout";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/sign-in")({
  beforeLoad: async ({ context }) => ({
    settingsTenant: await context.queryClient.fetchQuery({
      queryKey: queryKeys.tenants.detail(context.tenant.slug),
      queryFn: () => fetchTenantDetail(context.tenant.id),
      staleTime: 0,
    }),
  }),
  component: SignInSettingsLayout,
});
